import { useState, useEffect } from "react";
import { saveItemGroup1, getAllItemGroups } from "../Api/ItemGroup1";
import { Container, Form, Button, Row, Col } from "react-bootstrap";

import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";

const ItemGroup1 = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [itemGroups, setItemGroups] = useState([]);
  const [itemGroup1Data, setItemGroup1Data] = useState({
    code: "",
    description: "",
    itemGroupCode: "",
  });

  // Fetch item groups for dropdown
  useEffect(() => {
    const fetchItemGroups = async () => {
      try {
        const data = await getAllItemGroups();
        setItemGroups(data);
      } catch (error) {
        toast.error("Failed to load item groups");
      }
    };
    fetchItemGroups();
  }, []);

  const handleChange = (e) => {
    setItemGroup1Data({ ...itemGroup1Data, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userId = userDetails?.userId;

    try {
      await saveItemGroup1(itemGroup1Data, userId);
      toast.success("🦄 Item Group 1 Added Successfully");
      setItemGroup1Data({
        code: "",
        description: "",
        itemGroupCode: "",
      });
      navigate("/viewItemGroup1"); 
    } catch (error) {
      toast.error(error.message || "🦄 Some Error Happened");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      
        <div className="main-content expand">
          <Container fluid className="fields-container">
            <h2 className="fields-title">Item Group 1</h2>

            <Form onSubmit={handleSubmit} className="fields-form">
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Code <span className="text-red">**</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="code"
                      value={itemGroup1Data.code}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Description <span className="text-red">**</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="description"
                      value={itemGroup1Data.description}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Item Group <span className="text-red">**</span>
                    </Form.Label>
                    <Form.Select
                      name="itemGroupCode"
                      value={itemGroup1Data.itemGroupCode}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Item Group</option>
                      {itemGroups.map((group) => (
                        <option key={group.code} value={group.code}>
                          {group.code} - {group.description}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              <div className="fields-btn-container">
                <Button variant="primary" type="submit" className="fields-submit">
                  Save Item Group 1
                </Button>
              </div>
            </Form>
          </Container>
        </div>
     

      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </>
  );
};

export default ItemGroup1;